import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import * as React from 'react';
import VERSION from '../version';
import If from './If';
import { TypeOcr, TypeOcrH6 } from './Types';
import { useUser } from './UserProvider';

function TikTokIcon() {
  return (
    <SvgIcon>
      <svg
        fill='#000000'
        width='800px'
        height='800px'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
        xmlSpace='preserve'
      >
        <path d='M19.589 6.686a4.793 4.793 0 0 1-3.77-4.245V2h-3.445v13.672a2.896 2.896 0 0 1-5.201 1.743l-.002-.001.002.001a2.895 2.895 0 0 1 3.183-4.51v-3.5a6.329 6.329 0 0 0-5.394 10.692 6.33 6.33 0 0 0 10.857-4.424V8.687a8.182 8.182 0 0 0 4.773 1.526V6.79a4.831 4.831 0 0 1-1.003-.104z' />
      </svg>
    </SvgIcon>
  );
}
function DiscordIcon() {
  return (
    <SvgIcon>
      <svg
        id='Discord-Logo'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 126.644 96'
      >
        <path
          id='Discord-Symbol-Black'
          d='M81.15,0c-1.2376,2.1973-2.3489,4.4704-3.3591,6.794-9.5975-1.4396-19.3718-1.4396-28.9945,0-.985-2.3236-2.1216-4.5967-3.3591-6.794-9.0166,1.5407-17.8059,4.2431-26.1405,8.0568C2.779,32.5304-1.6914,56.3725.5312,79.8863c9.6732,7.1476,20.5083,12.603,32.0505,16.0884,2.6014-3.4854,4.8998-7.1981,6.8698-11.0623-3.738-1.3891-7.3497-3.1318-10.8098-5.1523.9092-.6567,1.7932-1.3386,2.6519-1.9953,20.281,9.547,43.7696,9.547,64.0758,0,.8587.7072,1.7427,1.3891,2.6519,1.9953-3.4601,2.0457-7.0718,3.7632-10.835,5.1776,1.97,3.8642,4.2683,7.5769,6.8698,11.0623,11.5419-3.4854,22.3769-8.9156,32.0509-16.0631,2.626-27.2771-4.496-50.9172-18.817-71.8548C98.9811,4.2684,90.1918,1.5659,81.1752.0505l-.0252-.0505ZM42.2802,65.4144c-6.2383,0-11.4159-5.6575-11.4159-12.6535s4.9755-12.6788,11.3907-12.6788,11.5169,5.708,11.4159,12.6788c-.101,6.9708-5.026,12.6535-11.3907,12.6535ZM84.3576,65.4144c-6.2637,0-11.3907-5.6575-11.3907-12.6535s4.9755-12.6788,11.3907-12.6788,11.4917,5.708,11.3906,12.6788c-.101,6.9708-5.026,12.6535-11.3906,12.6535Z'
        />
      </svg>
    </SvgIcon>
  );
}
const linkStyle = {
  color: '#474545',

  textDecoration: 'none',
  fontFamily: 'OCR A Std',
  fontSize: '0.9rem',
};

const linkStyleSmall = {
  fontFamily: 'OCR A Std',
  textDecoration: 'none',
  fontSize: '0.9rem',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
};
const sentence = {
  color: 'black',
  textDecoration: 'none',
  fontFamily: 'Ocr A Std',
};

export default function Footer() {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));
  const user = useUser();

  return (
    <>
      <Box sx={{ backgroundColor: 'secondary.main' }}>
        <Divider
          sx={{ mb: 2 }}
          style={{ width: '100%' }}
          flexItem
          role='presentation'
          color='black'
        ></Divider>
        <Stack
          direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
          ml={3}
        >
          <Stack
            sx={{ mr: 2, ml: 1, mb: 1, width: { md: '36%', sm: '100%' } }}
            justifyContent='space-between'
          >
            <Link to='/' style={sentence}>
              <TypeOcrH6>Noise Engineering</TypeOcrH6>
              <Typography>
                Not only do Noise Engineering products sound great, they have a
                personality all their own. What happens when you close the door
                to your studio? Probably nothing... Just don't feed them after
                midnight.
              </Typography>
            </Link>
            <If value={user.verified}>
              <Typography>
                {user?.user?.email}
                <br />
                {VERSION.PROJECT +
                  ' / ' +
                  VERSION.BRANCH +
                  ' / ' +
                  VERSION.VERSION +
                  ' / ' +
                  user?.ping?.version?.VERSION}
                <br />
                {(user?.perms).toString()}
              </Typography>
            </If>

            <If value={!user.verified}>
              <Typography>
                {VERSION.PROJECT +
                  ' / ' +
                  VERSION.BRANCH +
                  ' / ' +
                  VERSION.VERSION}
              </Typography>
            </If>
          </Stack>
          <If value={!isSmall}>
            <Stack sx={{ mr: 1, mb: 1 }} width='16%'>
              <Link to='/collections/all'>
                <TypeOcr
                  color='success.light'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                  fontSize='0.9rem'
                >
                  SHOP
                </TypeOcr>
              </Link>

              <Link to='/pages/open-source-notice'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  OPEN-SOURCE NOTICE
                </TypeOcr>
              </Link>

              <Link to='/pages/refund-policy'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {' '}
                  REFUNDS & RETURNS
                </TypeOcr>
              </Link>
              <Link to='/pages/shipping-policy'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  SHIPPING
                </TypeOcr>
              </Link>
            </Stack>
            <Stack width='16%' sx={{ mb: 1, mr: 2 }}>
              <Link to='/blogs/loquelic-literitas-the-blog/'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {' '}
                  BLOG
                </TypeOcr>
              </Link>{' '}
              <Link to='/pages/about'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {' '}
                  ABOUT US
                </TypeOcr>
              </Link>
              <Link to='/pages/environment'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {' '}
                  SUSTAINABILITY
                </TypeOcr>
              </Link>
            </Stack>
            <Stack sx={{ mr: 1, mb: 1 }} width='16%'>
              <Link to='/pages/support'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  SUPPORT
                </TypeOcr>
              </Link>
              <a href='/pages/retailers'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {' '}
                  RETAILERS
                </TypeOcr>
              </a>

              <Link to='/portal/univer-inter'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                    textTransform: 'uppercase',
                  }}
                >
                  {' '}
                  Univer Inter Setup
                </TypeOcr>
              </Link>
              <Link to='/portal/login'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {' '}
                  LOG IN
                </TypeOcr>
              </Link>
            </Stack>
            <Stack sx={{ mb: 2 }} width='16%'>
              <a href='https://www.instagram.com/noiseeng/'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {' '}
                  IG: MODULES
                </TypeOcr>
              </a>
              <a href='https://www.instagram.com/noiseengplugins/'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {' '}
                  IG: PLUGINS
                </TypeOcr>
              </a>
              <a href='https://www.instagram.com/noiseengpedals/'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  {' '}
                  IG: PEDALS
                </TypeOcr>
              </a>
              <a href='https://www.youtube.com/channel/UCTa3nl2XQR3v_BobASbKPUQ'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  YOUTUBE
                </TypeOcr>
              </a>
              <a href='https://discord.gg/QZsTDJGnmD'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  DISCORD
                </TypeOcr>
              </a>
              <a href='https://www.facebook.com/noiseeng/'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  FACEBOOK
                </TypeOcr>
              </a>
              <a href='https://www.tiktok.com/@noiseeng'>
                <TypeOcr
                  color='success.light'
                  fontSize='0.9rem'
                  sx={{
                    ':hover': {
                      color: 'white',
                      cursor: 'pointer',
                    },
                  }}
                >
                  TIKTOK
                </TypeOcr>
              </a>
            </Stack>
          </If>
          <If value={isSmall}>
            <Stack>
              <Stack direction='row' justifyContent='space-evenly' mt={4}>
                <a
                  href='https://www.instagram.com/noiseeng/'
                  style={linkStyleSmall}
                >
                  <InstagramIcon fontSize='large' color='info' />
                  <TypeOcr
                    color='info.main'
                    mt={1}
                    sx={{
                      ':hover': {
                        color: 'white',
                        cursor: 'pointer',
                      },
                    }}
                  >
                    MODULES
                  </TypeOcr>
                </a>
                <a
                  href='https://www.instagram.com/noiseengplugins/'
                  style={linkStyleSmall}
                >
                  <InstagramIcon color='info' fontSize='large' />
                  <TypeOcr
                    color='info.main'
                    mt={1}
                    sx={{
                      ':hover': {
                        color: 'white',
                        cursor: 'pointer',
                      },
                    }}
                  >
                    PLUGINS
                  </TypeOcr>
                </a>
                <a
                  href='https://www.instagram.com/noiseengpedals/'
                  style={linkStyleSmall}
                >
                  <InstagramIcon color='info' fontSize='large' />
                  <TypeOcr
                    color='info.main'
                    mt={1}
                    sx={{
                      ':hover': {
                        color: 'white',
                        cursor: 'pointer',
                      },
                    }}
                  >
                    PEDALS
                  </TypeOcr>
                </a>
              </Stack>
              <Stack
                direction='row'
                justifyContent='space-evenly'
                mt={6}
                mb={4}
              >
                <a
                  href='https://www.youtube.com/channel/UCTa3nl2XQR3v_BobASbKPUQ'
                  style={linkStyleSmall}
                >
                  <YouTubeIcon
                    color='info'
                    fontSize='large'
                    sx={{
                      ':hover': {
                        color: 'white',
                        cursor: 'pointer',
                      },
                    }}
                  />
                </a>
                <a
                  href='https://www.facebook.com/noiseeng/'
                  style={linkStyleSmall}
                >
                  <FacebookIcon
                    color='info'
                    fontSize='large'
                    sx={{
                      ':hover': {
                        color: 'white',
                        cursor: 'pointer',
                      },
                    }}
                  />
                </a>
                <a href='https://discord.gg/QZsTDJGnmD' style={linkStyleSmall}>
                  <DiscordIcon
                    color='info'
                    fontSize='large'
                    sx={{
                      ':hover': {
                        color: 'white',
                        cursor: 'pointer',
                      },
                    }}
                  />
                </a>
                <a
                  href='https://www.tiktok.com/@noiseeng'
                  style={linkStyleSmall}
                >
                  <TikTokIcon
                    color='info'
                    fontSize='large'
                    sx={{
                      ':hover': {
                        color: 'white',
                        cursor: 'pointer',
                      },
                    }}
                  />
                </a>
              </Stack>
            </Stack>
          </If>
        </Stack>
      </Box>
      <Box sx={{ backgroundColor: 'info.main' }}>
        <Stack
          direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
          justifyContent={{ xs: 'center', sm: 'center', md: 'space-evenly' }}
          alignItems={{ xs: 'center', md: 'space-evenly' }}
        >
          <a href='https://www.onepercentfortheplanet.org/'>
            <Box sx={{ m: 3, fit: 'scale-down' }}>
              <StaticImage
                src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/1ftp_BusinessMember_Horizontal_White-500x213-e420542e-34b6-4bd8-b01a-1166fc106d6f.png?v=1714157929'
                height={100}
                alt='Noise Engineering is a proud member of 1% for the Planet'
              />
            </Box>
          </a>
          <a href='https://seatrees.org/'>
            <Box sx={{ m: 3, fit: 'scale-down' }}>
              <StaticImage
                src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/SeaTrees_S-Surf-logo-21-OL-01.png?v=1714158782'
                height={100}
                alt='Noise Engineering is certified Ocean Positive by Sea Trees'
              />
            </Box>
          </a>
          <a href='https://greenbusinessca.org/metrics'>
            <Box sx={{ m: 3, fit: 'scale-down' }} width='100%'>
              <StaticImage
                src='https://cdn.shopify.com/s/files/1/0552/0923/0485/files/LA_Green_Business_Logo.png?v=1716510515'
                height={150}
                alt='Noise Engineering is a certified LA Green Business at the Innovator level.'
              />
            </Box>
          </a>
        </Stack>
      </Box>

      <Box sx={{ backgroundColor: 'info.main' }}>
        <Stack
          direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
          justifyContent={{ xs: 'center', sm: 'center', md: 'space-around' }}
          alignItems='center'
        >
          <Typography fontSize='0.7rem' color='error.main'>
            (c)2024 NOISE ENGINEERING
          </Typography>
          <Link to='/pages/privacy-policy' className='classBlackBg'>
            <Typography fontSize='0.7rem'>PRIVACY POLICY</Typography>
          </Link>
          <Link to='/pages/terms-of-service' className='classBlackBg'>
            <Typography fontSize='0.7rem'>TERMS & CONDITIONS</Typography>
          </Link>
          <Link to='/pages/eula' className='classBlackBg'>
            <Typography fontSize='0.7rem'>EULA</Typography>
          </Link>
          <a
            href='https://policies.google.com/technologies/partner-sites'
            className='classBlackBg'
          >
            <Typography fontSize='0.7rem'> GOOGLE ANALYTICS</Typography>
          </a>
        </Stack>
      </Box>
    </>
  );
}
/*   <Link to='/collections/platform' style={linkStyle}>
                PLATFORMS
              </Link>*/
